import { render, staticRenderFns } from "./RingChart.vue?vue&type=template&id=c2ea3226&scoped=true"
import script from "./RingChart.vue?vue&type=script&lang=js"
export * from "./RingChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ea3226",
  null
  
)

export default component.exports